type CategoryTitle = 'facebook' | 'google'

export const generateLogoUrl = (categoryTitle: CategoryTitle) => {
  const logoMap = {
    facebook: '/Facebook_logo_PNG9.png',
    google: '/Google-logo.png',
  } as { [key: string]: string }

  return logoMap[categoryTitle]
}